import Vue from 'vue'
import VueRouter from 'vue-router';
import App from './App.vue'
import VueResource from 'vue-resource'

Vue.use(VueRouter);
Vue.config.productionTip = false

Vue.use(VueResource);

import Home from './components/Home.vue';
import About from './components/About.vue';
import Services from './components/Services.vue';
import Location from './components/Location.vue';
import Contact from './components/Contact.vue';
import Imprint from './components/Imprint.vue';
import Privacy from './components/Privacy.vue';
import Reservation from './components/Reservation.vue';
import Unsubscribe from './components/Unsubscribe.vue';
import SatisfactionReport from '@/components/SatisfactionReport'

const router = new VueRouter({
	mode: 'history',
	base: __dirname,
	routes: [
		{ path: '/', component: Home },
		{ path: '/about', component: About },
		{ path: '/services', component: Services },
		{ path: '/location', component: Location },
		{ path: '/contact', component: Contact },
		{ path: '/imprint', component: Imprint },
		{ path: '/privacy', component: Privacy },
		{ path: '/reservation', component: Reservation },
		{ path: '/unsubscribe', component: Unsubscribe },
		{ path: '/satisfaction-report', component: SatisfactionReport },
	]
});

new Vue({
	router,
	render: h => h(App),
}).$mount('#app')

Vue.prototype.$scrollToTop = () => window.scrollTo(0, 0)
